import { render, staticRenderFns } from "./laptopPriceList.vue?vue&type=template&id=4ef6136e&scoped=true&"
import script from "./laptopPriceList.vue?vue&type=script&lang=js&"
export * from "./laptopPriceList.vue?vue&type=script&lang=js&"
import style0 from "./laptopPriceList.vue?vue&type=style&index=0&id=4ef6136e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef6136e",
  null
  
)

export default component.exports